var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { and, not, or, reads, readOnly } from '@ember/object/computed';
import { A } from '@ember/array';
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
let UserPermissions = (_dec = readOnly('currentUserData.data'), _dec2 = reads('data.canSeeContracts'), _dec3 = and('data.canUseCustomerListInTransactions', 'data.shouldShowCustomerList'), _dec4 = reads('data.canViewGiftCardHistoryEvents'), _dec5 = not('data.canSeeRewardsTab'), _dec6 = not('data.shouldShowMarketing'), _dec7 = reads('data.shouldShowMarketing'), _dec8 = reads('data.canMultiunit'), _dec9 = or('data.canUseCardOnFileInIosRegister', 'data.canUseCardOnFileInAndroidRegister'), _dec10 = or('data.canUseVoidsIos', 'data.canUseCompsIos'), _dec11 = reads('data.isInCountryWithFlexibleCloseOfDay'), _dec12 = not('data.canUseOfflineMode'), _dec13 = computed('data.currencyCode'), _dec14 = reads('data.canReportsSeeDepositLinksInTransactionBlade'), _dec15 = reads('data.canSeeRiskManagerNotEnrolledFeatures'), (_class = class UserPermissions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    // CONTRACTS
    _initializerDefineProperty(this, "canSeeContracts", _descriptor3, this);
    // CUSTOMER DIRECTORY
    _initializerDefineProperty(this, "canUseTransactionCustomerName", _descriptor4, this);
    // GIFT CARDS
    _initializerDefineProperty(this, "canViewGiftCardHistoryEvents", _descriptor5, this);
    // LOYALTY
    _initializerDefineProperty(this, "cannotSeeRewardsTab", _descriptor6, this);
    // MARKETING
    _initializerDefineProperty(this, "cannotShowMarketing", _descriptor7, this);
    _initializerDefineProperty(this, "canShowMarketing", _descriptor8, this);
    // MULTIUNIT
    _initializerDefineProperty(this, "isMultiunit", _descriptor9, this);
    // PAYMENTS
    _initializerDefineProperty(this, "canUseCardOnFileInRegister", _descriptor10, this);
    _initializerDefineProperty(this, "useCompOrVoidReasons", _descriptor11, this);
    _initializerDefineProperty(this, "canSeeFlexibleSettlement", _descriptor12, this);
    _initializerDefineProperty(this, "cannotUseOfflineMode", _descriptor13, this);
    // REPORTS
    _initializerDefineProperty(this, "canReportsSeeDepositLinksInTransactionBlade", _descriptor14, this);
    // RISK
    _initializerDefineProperty(this, "canSeeRiskManagerNotEnrolledFeatures", _descriptor15, this);
  }
  get canUseSwedishRounding() {
    return A(['AED', 'ARS', 'AUD', 'BAM', 'BRL', 'CAD', 'CHF', 'CNY', 'DKK', 'EGP', 'HKD', 'ILS', 'INR', 'ISK', 'MXN', 'NZD', 'SGD', 'ZAR']).includes(this.data.currencyCode);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canSeeContracts", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canUseTransactionCustomerName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canViewGiftCardHistoryEvents", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cannotSeeRewardsTab", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cannotShowMarketing", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canShowMarketing", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isMultiunit", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "canUseCardOnFileInRegister", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "useCompOrVoidReasons", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "canSeeFlexibleSettlement", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "cannotUseOfflineMode", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "canUseSwedishRounding", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "canUseSwedishRounding"), _class.prototype), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "canReportsSeeDepositLinksInTransactionBlade", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "canSeeRiskManagerNotEnrolledFeatures", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { UserPermissions as default }; // This is how TypeScript knows how to look up the service.
/** @hidden */